<template>
  <div class="container-fluid container-wrap col-sm-12 col-xs-12 ">
    <div class="row justify-content-center">
      <div class="col-sm-12 col-xs-12">
        <div class="card-header pb-0 col-sm-12 d-flex">
          <div class="col-sm-12 col-xs-12">
            <div class="col-sm-12 col-xs-12 justify-content-between titleContainer">
              <h3 class="title">전자계약</h3>
              <h5 class="desc">물품 공급 계약, 장비 계약 등 각종 계약을 관리할 수 있습니다.</h5>
            </div>
          </div>
        </div>
        <div class="small-header">
          신규 계약 추가하기
        </div>
        <a-row type="flex" align="middle" :gutter=30 justify="center">
          <a-col class="col-sm-12 col-xs-12 contract-container">
            <div class="contract-title">
              {{ pageTitle }}
            </div>
            <div class="contract-section-wrap">
              <div class="contract-section-title">매수인 (고객)</div>
              <div class="contract-items-container">
                <contract-item-wrap
                    label="거래처명"
                    :is-required="true"
                    :class="'fixed-btn-110 mobile-wrap'"
                    :errorIds="['company-name-error']"
                >
                  <div class="disabled-event-wrap">
                    <input
                        ref="companyName"
                        class="ant-like-input"
                        type="text"
                        :disabled="!directInputClientName"
                        v-model="clientData.companyName"
                        placeholder="거래처 검색을 통해 입력해주세요"
                    />
                    <div
                        v-if="!directInputClientName"
                        class="fire-event-container"
                        @click="uiHandler.handleModal.client.show"
                    />
                  </div>
                  <div class="checkbox-container">
                    <a-checkbox v-model:checked="directInputClientName" @change="uiHandler.checkDirectInputClientName">직접입력</a-checkbox>
                  </div>
                  <button class="btn-darkgray btn-hover"
                          :disabled="directInputClientName"
                          @click="uiHandler.handleModal.client.show">
                    거래처 검색
                  </button>
                </contract-item-wrap>
                <contract-item-wrap
                    label="대표자 정보"
                    :is-required="true"
                    :class="'divide-two'"
                    :errorIds="['ceo-name-error', 'ceo-birthday-error']"
                >
                  <div class="input-area">
                    <input
                        class="full-width ant-like-input"
                        type="text"
                        placeholder="이름 입력"
                        ref="ceoName"
                        v-model="clientData.ceo.name"
                        @input="uiHandler.handleRemoveError('ceoName', 'ceo-name-error')"
                    />
                  </div>
                </contract-item-wrap>
                <contract-item-wrap
                    label="거래처 주소"
                    :is-required="true"
                    :class="'fixed-btn-110 mobile-wrap'"
                    :errorIds="['address-error']"
                >
                  <div class="disabled-event-wrap">
                    <textarea
                        maxlength="67"
                        type="text"
                        v-model="clientData.address"
                        ref="address"
                        placeholder="주소 검색을 통해 입력해주세요"
                        class="address ant-like-input"
                        style="width: 100%;"
                    />
                  </div>
                  <div class="button-wrapper">
                    <button class="btn-darkgray btn-hover" @click="uiHandler.searchAddress">
                      주소 검색
                    </button>
                  </div>
                </contract-item-wrap>
                <contract-item-wrap
                    label="연락처"
                    :is-required="true"
                    :errorIds="['mobile-error']"
                >
                  <div class="input-area icon" ref="companyMobileNumber">
                    <i class="fa-solid fa-mobile-screen"/>
                    <input
                        class="full-width"
                        type="text"
                        maxlength="13"
                        placeholder="010-0000-0000"
                        v-model="clientData.contact.mobile"
                        @input="uiHandler.changeMobileNumber(true)"
                    />
                  </div>
                </contract-item-wrap>
                <contract-item-wrap
                    label="제품명"
                    :is-required="true"
                    :class="'divide-two flex-col'"
                    :errorIds="['product-name-error']"
                    
                >
                  <div class="flex-row" style="width: 100%; height: 40px; align-items: center;">
                    <div class="input-area flex-row" style="width: 100%; height: 40px; align-items: center;">
                      <div class="checkbox-container flex-row" style="width: 100%; height: 40px; align-items: center;">
                        <a-checkbox-group @change="onCheckProductName" v-model:value="contractInfo.productName" :options="contractInfo.productNameOptions" />
                      </div>
                    </div>
                  </div>
                </contract-item-wrap>
                <div class="flex-row" style="align-items: flex-start;">
                  <contract-item-wrap
                      label="설치 일자"
                      :is-required="true"
                      :errorIds="['install-date-error']"
                  >
                    <div class="custom-calendar-wrap single" ref="installDate" style="margin-right: 20px">
                      <a-date-picker
                          type="date"
                          class="contract-item"
                          placeholder="설치 일자"
                          v-model:value="contractInfo.installDate"
                          :locale="locale"
                          :bordered="false"
                          @change="uiHandler.handleInstallDate"
                      />
                    </div>
                  </contract-item-wrap>
                  <contract-item-wrap
                      label="설치 대수"
                      :is-required="true"
                      :errorIds="['install-count-error']"
                  >
                    <div class="input-area" >
                      <input
                          ref="installCount"
                          class="full-width ant-like-input"
                          type="text"
                          placeholder="설치대수를 입력해주세요."
                          v-model="contractInfo.installCount"
                          @input="uiHandler.handleInstallCount"
                      />
                    </div>
                  </contract-item-wrap>
                </div>
                <div class="flex-row mobile-column" style="align-items: flex-start;">
                  <contract-item-wrap
                      label="검사 설비"
                      :is-required="true"
                      :class="'divide-two'"
                      :errorIds="['inspection-equipment-error']"
                  >
                    <div class="input-area" style="width:135px; flex:0 0 auto;">
                      <div class="checkbox-container" style="width: 100%; display: flex;">
                        <a-checkbox style="width:135px; flex:0 0 auto;" v-model:checked="contractInfo.inspectionEquipment.check" @change="uiHandler.changeInspectionEquipment">디지털 멀티미터</a-checkbox>
                      </div>
                    </div>
                    <div class="input-area ant-like-input mobile-width-full" style="width:232px; height: 40px; padding: 0px; flex:0 0 auto; border-radius: 8px;" ref="inspectionEquipmentName" >
                      <a-select
                          :bordered="false"
                          style="width:230px; flex:0 0 auto; padding: 0;border: 0;"
                          class="full-width"
                          type="text"
                          placeholder="디지털 멀티미터를 입력해주세요."
                          v-model:value="contractInfo.inspectionEquipmentName"
                          @change="uiHandler.handleChangeInspectionEquipmentName"
                      >
                        <a-select-option value="" selected>디지털 멀티미터를 입력해주세요.</a-select-option>
                        <a-select-option value="I1092067">I1092067</a-select-option>
                        <a-select-option value="SH003515">SH003515</a-select-option>
                        <a-select-option value="SH047793">SH047793</a-select-option>
                      </a-select>
                    </div>
                  </contract-item-wrap>
                  </div>
              </div>
            </div>
            <div class="contract-section-wrap">
              <div class="contract-section-title">설치담당자 확인</div>
              <div class="contract-items-container">
                <div class="flex-row mobile-column" style="align-items: flex-start;">
                  <contract-item-wrap
                      label="성명 및 연락처"
                      :is-required="true"
                      :class="'divide-two'"
                      :errorIds="['install-person-name-error']"
                      style="width: 150%; padding-right: 10px;"
                  >
                    <div class="input-area ant-like-input" ref="installationPersonName" style="box-sizing: border-box; height: 40px; padding: 0px;">
                      <a-select 
                        style="width: 100%; height: 40px;"
                        :bordered="false"
                        v-model:value="installationPersonName"
                        placeholder="설치담당자를 선택해 주세요."
                        :showSearch="true"
                        @change="uiHandler.handleChangeInstallationPerson"
                      >
                      
                        <a-select-option
                        v-for="(item, index) in installationPersons" 
                        :value="item.name"
                        :key="index"
                        @click="uiHandler.handleChangeInstallationPerson(item)"
                        >
                          {{ item.name }}
                        </a-select-option>
                      </a-select>
                    </div>
                  </contract-item-wrap>
                  <div class="contract-item-wrap">
                    <div class="contract-content">
                      <div class="contract-item-input-wrap divide-two">
                        <div class="input-area icon" ref="installationPersonMobileNumber">
                          <i class="fa-solid fa-mobile-screen"/>
                          <input
                              type="text"
                              maxlength="13"
                              placeholder="010-0000-0000"
                              v-model="installationPersonMobileNumber"
                              @input="uiHandler.changeMobileNumberforInstallationPerson(false)"
                          />
                        </div>
                      </div>
                    </div>
                    <div class="error-message-wrap" style="margin-left: 0;">
                      <div id="install-person-mobile-error" class="error-message"></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="contract-section-wrap">
              <div class="contract-section-title">영업담당자 확인</div>
              <div class="contract-items-container">
                <div class="flex-row mobile-column" style="align-items: flex-start;">
                  <contract-item-wrap
                      label="지점 및 성명"
                      :is-required="true"
                      :class="'divide-two'"
                      :errorIds="['dept-error']"
                      style="width: 150%; padding-right: 10px;"
                  >
                    <div class="input-area name" ref="dept">
                      <a-select v-if="directInputClientName"
                                :value="selectedDept"
                                show-search
                                style="width: 100%;"
                                @change="val => {
                                  personInCharge.dept = val
                                  selectedDept = val
                                }"
                                placeholder="지점을 선택해 주세요."
                                :notFoundContent="null"
                                :options="deptNames"></a-select>
                      <input
                          v-else
                          class="full-width ant-like-input"
                          type="text"
                          placeholder="지점명 입력"
                          v-model="personInCharge.dept"
                          @input="uiHandler.handleRemoveError('dept', 'dept-error')"
                      />
                    </div>
                  </contract-item-wrap>
                  <div class="contract-item-wrap">
                    <div class="contract-content">
                      <div class="contract-item-input-wrap divide-two">
                        <div class="input-area name" ref="personInChargeName">
                          <input
                          class="full-width ant-like-input"
                          type="text"
                          placeholder="이름 입력"
                          :value="personInCharge.name"
                          @input="uiHandler.changePersonInChareName"
                        />
                        </div>
                      </div>
                    </div>
                    <div class="error-message-wrap" style="margin-left: 0;">
                      <div id="person-in-charge-error" class="error-message"></div>
                    </div>
                  </div>
                </div>
                <contract-item-wrap
                    label="연락처"
                    :is-required="true"
                    :class="'divide-two'"
                    :errorIds="['person-in-charge-mobile-error']"
                >
                  <div class="input-area icon" ref="personMobileNumber">
                    <i class="fa-solid fa-mobile-screen"/>
                    <input
                        type="text"
                        maxlength="13"
                        placeholder="010-0000-0000"
                        v-model="personInCharge.mobile"
                        @input="uiHandler.changeMobileNumber(false)"
                    />
                  </div>
                </contract-item-wrap>
              </div>
            </div>
            <div class="contract-footer">
              <button
                  class="contract-cancel-btn btn-hover"
                  @click="$router.push(contractTypesPath)"
              >
                취소
              </button>
              <button
                  class="contract-submit-btn btn-hover preview-button"
                  @click="uiHandler.handleModal.contractDraftModal.show"
              >
                미리보기
              </button>
              <button
                  class="contract-submit-btn btn-hover"
                  @click="(uiHandler.createTempContract)"
                  style="font-weight: 700;"
              >
                계약서 임시저장
              </button>
              <button
                  class="contract-submit-btn btn-hover"
                  @click="uiHandler.handleModal.summary.show"
                  style="font-weight: 700;"
              >
                계약서 작성 완료
              </button>
            </div>
          </a-col>
          <a-col></a-col>
          <a-col class="col-sm-12 col-xs-12 contract-container is-desktop-only">
            <div class="contract-title">
              {{ pageTitle }} 미리보기
              <LottieAnimation
                  v-if="previewLoading"
                  :animation-data="loadingAnimation"
                  :auto-play="true"
                  :loop="true"
                  :speed="1"
                  class="lottie-player-component loading-img"
                  ref="anim"
              />
              <a-button v-else type="primary" @click="uiHandler.makeContractDraft">
                <i class="fa-solid fa-rotate-right"></i><span style="margin-left: 5px">새로고침</span>
              </a-button>
            </div>
            <div class="iframe-wrap">
              <iframe ref="previewIframe" :src=modal.contractDraft.embeddedUrl class="preview-iframe" style="height: 1015px"></iframe>
            </div>
          </a-col>
        </a-row>
      </div>
    </div>
  </div>
  <search-client-modal
      :show-modal="modal.client.show"
      @close-modal="uiHandler.handleModal.client.close"
      @complete-search="uiHandler.handleModal.client.handleEvent.selectClient"
  />
  <summary-contract-modal
      :show-modal="modal.summary.show"
      :summary-contents="summary"
      @summary-confirm="uiHandler.handleModal.summary.handleEvent.summaryConfirm"
      @close-modal="uiHandler.handleModal.summary.close"
  />
  <create-contract-success-modal-v3
      :show-modal="modal.createSuccess.show"
      :secure-link-param="secureLinkParam"
      @close-modal="uiHandler.handleModal.createSuccess.close"
  />
  <contract-draft-modal
      :show-modal="modal.contractDraft.show"
      :embedded-url="modal.contractDraft.embeddedUrl"
      @close-modal="uiHandler.handleModal.contractDraftModal.close"
  />
</template>
<script>
import {
  oneBtnDialog,
  phoneNumberFormatter,
  formatCommaNumber,
  logging,
  businessNumberFormatter, twoBtnDialog,
} from '@/utils/utils';
import {
  RouterEnum,
} from '@/enums/router.enums';
import ContractItemWrap from '@/views/ContractManagement/components/ContractItemWrap';
import SignModal from '@/views/ContractManagement/components/SignModal';
import SearchClientModal from '@/views/ContractManagement/components/SearchClientModal';
import {localStorageEnums} from "@/enums/localStorage.enums";
import SummaryContractModal from "@/views/ContractManagement/components/SummaryContractModal.vue";
import CreateContractSuccessModalV3 from "@/views/ContractManagementV3/components/CreateContractSuccessModalV3.vue";
import ContractDraftModal from "@/views/ContractManagement/components/ContractDraftModal.vue";
import {LottieAnimation} from "lottie-web-vue";
import loadingAnimation from "@/assets/img/loading.json";
// v3: contracts-api 전용 api 모듈 + axios 인스턴스 (BnkV3/MulpumV6V3 와 동일 조리법).
// getAccountsList(설치담당자 목록, /contracts/installation-persons)도 contracts-api 로 호출한다 —
// inapi 라우트는 2026-08-30 제거됨(M6). SearchClientModal(거래처 검색)만 companies 도메인이라 v1 유지.
import contractApi from "@/views/ContractManagementV3/api";
import contractsApiInstance from "@/contractsApi";
import {resolveContractCreateRouteName} from "@/views/ContractManagementV3/routeMap";
import locale from 'ant-design-vue/es/date-picker/locale/ko_KR';
import dayjs from 'dayjs';
import {ContractTypeEnum} from "@/views/ContractManagement/enums";
import {validateContractClientNameLength} from "@/views/ContractManagement/contracts/contractValidationUtils";

import { attachPrixPreviewFit } from '@/utils/prixPreviewFit';
import {CONTRACT_TYPES_PATH} from '@/utils/contractConsole';
export default {
  // v1 은 name 이 Robot.name 으로 잘못 복사돼 있었다(컴포넌트 name 은 라우팅에 안 쓰여 무해).
  // v3 는 MulpumV6V3 관례대로 라우트 name(routeMap 매핑)과 일치시킨다.
  name: resolveContractCreateRouteName(RouterEnum.ContractManagement.Contracts.Dentium.SeolqiChair.name),
  components: {
    LottieAnimation,
    ContractDraftModal,
    CreateContractSuccessModalV3,
    SummaryContractModal,
    ContractItemWrap,
    SignModal,
    SearchClientModal,
  },
  props: {
    templateId: {
      type: String,
      required: true,
    }
  },
  computed: {
    productRemarkLength() {
      return Array.from(this.productRemark).length;
    },
    formattedTotalPrice() {
      return formatCommaNumber(this.contractInfo.totalPrice);
    },
    formattedInstallCost() {
      return formatCommaNumber(this.additionalInfo.installCost);
    },
  },
  data() {
    return {
      makeContractDraftDebouncing:null,
      loadingAnimation,
      locale,
      pageTitle: this.$route.query.name ?? '',
      logging,
      uiHandler: this.ui(),
      apiHandler: this.api(),
      contractTypesPath: CONTRACT_TYPES_PATH,
      contractType: ContractTypeEnum.chair설치확인서,
      contractTitle: 'Chair 제품설치 확인서',
      contractCreator: '',
      validateCount: 0,
      previewLoading: false,
      directInputClientName: false,
      deptNames: [],
      modal: {
        client: {
          show: false
        },
        sign: {
          show: false,
        },
        summary: {
          show: false,
        },
        createSuccess: {
          show: false,
        },
        contractDraft: {
          embeddedUrl: '',
          show: false
        }
      },
      summary: {
        "계약명": "",
        "병원명": "",
        "병원장명": "",
        "병원 주소": "",
        "병원 연락처": "",
        "총 계약 금액": "",
      },
      secureLinkParam: {
        contractId: '',
        participantId: '',
      },

      clientData: {
        companyName: '',
        address: '',
        cNo: '',
        ceo: {
          name: '',
          birthday: null,
        },
        contact: {
          phone: '',
          mobile: '',
          email: '',
        },
        rawHospitalData: {},
      },
      oldProductName : [],
      contractInfo: {
        productName: '',
        productNameOptions:[
          { 
            label:'bright Alone S',
            value:'bright Alone S'
          },
          {
            label:'bright Alone R',
            value:'bright Alone R'
          },
          {
            label:'bright Chair2',
            value:'bright Chair2'
          },
        ],
        contractDate: null,
        installDate: null,
        installCount: '',
        totalPrice: 0,
        selectedPaymentOption: 'CMS',
        inspectionEquipment:{
          check:true,
          value:''
        },
        inspectionEquipmentName:''
      },

      paymentInfo: {
        paymentOptions: [
          'CMS', '선수금', '현금', '신용카드',
        ],
        selectedPaymentOption: 'CMS',
        paymentDate: null,
      },
      productOptions: [
        {label: "T8 TAG 서빙로봇 -현대HD", value: "T8 TAG 서빙로봇 -현대HD"},
        {label: "서비(Servi)-서빙로봇 -베어로보틱스", value: "서비(Servi)-서빙로봇 -베어로보틱스"},
        {label: "서비 미니(Servi Mini)-서빙로봇 -베어로보틱스", value: "서비 미니(Servi Mini)-서빙로봇 -베어로보틱스"},
      ],
      productRemark: '',
      selectedValues: [],
      selectedDept: null,
      productInfo: [
        {name: '', unit: ''},
      ],
      additionalInfo: {
        deadline: null,
        installCost: 300000,
        warrantyPeriod: 3,
      },
      contractDate: dayjs(),
      personInCharge: {
        dept: '',
        name: '',
        mobile: '',
      },
      installationPersonName: '',
      installationPersonMobileNumber: '',
      installationPersons: []
    }
  },
  async mounted() {
    await this.uiHandler.getUserInfo();
    await this.uiHandler.makeContractDraft();
    await this.uiHandler.loadDeptNames();
    await this.uiHandler.loadTempContract();
    await this.getAccountsList();
    // 이벤트 리스너 등록
    window.removeEventListener('resize', this.uiHandler.checkScreenSizeAndFetch);
    window.addEventListener('resize', this.uiHandler.checkScreenSizeAndFetch);
    // 프릭스 미리보기를 컨테이너 폭에 맞춘다(창 크기 변화도 따라감).
    this.$nextTick(() => attachPrixPreviewFit(this.$refs.previewIframe));
  },
  beforeDestroy() {
    // 컴포넌트가 사라질 때 이벤트 리스너 해제
    window.removeEventListener('resize', this.uiHandler.checkScreenSizeAndFetch);
  },
  methods: {
    // 계정 리스트 가져오기
    async getAccountsList() {
      try {
          const response = await contractsApiInstance.get(`/contracts/installation-persons`);
          if (response.status === 200 || response.status === 201) {
            this.installationPersons = response.data;
          }
      } catch (error) {
          console.log(error);
          await oneBtnDialog('설치담당자 목록 조회 실패', '설치 담당자 목록을 가져오는데 실패했습니다.', false);
      }
    },
    onCheckProductName(){
        this.contractInfo.productName = this.contractInfo.productName.filter(i=>!this.oldProductName.includes(i));
        this.oldProductName = this.contractInfo.productName;
        document.getElementById('product-name-error').innerHTML = '';
    },
    twoBtnDialog,
    ui() {
      const handleChangeInspectionEquipmentName = () =>{
        this.$refs.inspectionEquipmentName.classList.remove('error');
        document.getElementById('inspection-equipment-error').innerHTML = '';
      }
      const handleChangeInstallationPerson = (currentData) =>{
        this.installationPersonName = currentData.name || '';
        this.installationPersonMobileNumber = currentData.mobile || '';
        this.$refs.installationPersonName.classList.remove('error');
        document.getElementById('install-person-name-error').innerHTML = '';
      }
      const changePersonInChareName = (event) =>{
        this.uiHandler.handleRemoveError('personInChargeName', 'person-in-charge-error'); 
        this.personInCharge.name = event.target.value
      }
      const changeInspectionEquipment = () =>{
        this.contractInfo.inspectionEquipment.value = this.contractInfo.inspectionEquipment.check ? '디지털 멀티미터' : '';
        document.getElementById('inspection-equipment-error').innerHTML = '';
      }
      const addProductInfo = async () => {
        if (this.productInfo.length >= 5) {
          await oneBtnDialog('입력 가능 수량 초과', '제품 정보를 5개 이상 입력할 수 없습니다.', false);
          return;
        }
        this.productInfo.push({name: '', unit: ''});
      }
      const removeProductInfo = (index) => {
        this.productInfo.split(index);
      }
      const handlePaymentOption = (option) => {
        this.paymentInfo.selectedPaymentOption = option;
        if (option !== 'CMS') this.paymentInfo.paymentDate = null;
        document.getElementById('payment-method-error').innerHTML = '';
      }
      const removeTotalPrice = (e) => {
        if (this.contractInfo.totalPrice === 0) e.target.value = '';
        return;
      }
      const removeInstallCost = (e) => {
        if (this.additionalInfo.installCost === 0) e.target.value = '';
        return;
      }
      const removeWarrantyPeriod = (e) => {
        if (this.additionalInfo.warrantyPeriod === 0) e.target.value = '';
        return;
      }
      const addZeroToTotalPrice = (e) => {
        if (this.contractInfo.totalPrice === 0) e.target.value = '0';
        return;
      }
      const addZeroToInstallCost = (e) => {
        if (this.additionalInfo.installCost === 0) e.target.value = '0';
        return;
      }
      const addZeroToWarrantyPeriod = (e) => {
        if (this.additionalInfo.warrantyPeriod === 0) e.target.value = '0';
        return;
      }
      const handleTotalPrice = (e) => {
        if (e.target.value === '00') {
          e.target.value = '0';
          this.contractInfo.totalPrice = 0;
        }
        if (isNaN(e.target.value)) e.target.value = e.target.value.replace(/[^0-9]/g, '');
        this.contractInfo.totalPrice = parseInt(e.target.value.replace(/[^0-9]/g, '')) || 0;
        this.$refs.totalPrice.classList.remove('error');
        document.getElementById('total-price-error').innerHTML = '';
      }
      const handleInstallCost = (e) => {
        if (e.target.value === '00') {
          e.target.value = '0';
          this.additionalInfo.installCost = 0;
        }
        if (isNaN(e.target.value)) e.target.value = e.target.value.replace(/[^0-9]/g, '');
        this.additionalInfo.installCost = parseInt(e.target.value.replace(/[^0-9]/g, '')) || 0;
        this.$refs.installCost.classList.remove('error');
        document.getElementById('install-cost-error').innerHTML = '';
      }
      const handleWarrantyPeriod = (e) => {
        if (e.target.value === '00') {
          e.target.value = '0';
          this.additionalInfo.warrantyPeriod = 0;
        }
        if (isNaN(e.target.value)) e.target.value = e.target.value.replace(/[^0-9]/g, '');
        this.additionalInfo.warrantyPeriod = parseInt(e.target.value.replace(/[^0-9]/g, '')) || 0;
        this.$refs.warrantyPeriod.classList.remove('error');
        document.getElementById('warranty-period-error').innerHTML = '';
      }
      const getContractTemplate = async () => {
        await this.apiHandler.getContractTemplate(this.templateId, (response) => {
        }, async (error) => {
          await oneBtnDialog('계약서 템플릿 로드 실패', '계약서 템플릿 로드에 실패했습니다.', false);
        })
      }
      const searchAddress = () => {
        new daum.Postcode({
          oncomplete: (data) => {
            var addr = ''; // 주소 변수

            if (data.userSelectedType === 'R') { // 사용자가 도로명 주소를 선택했을 경우
              addr = data.roadAddress;
            } else { // 사용자가 지번 주소를 선택했을 경우(J)
              addr = data.jibunAddress;
            }
            this.clientData.address = addr;
            if (this.clientData.address) {
              this.$refs.address.classList.remove('error');
              document.getElementById('address-error').innerHTML = '';
            }
          }
        }).open();
      }

      const validateRequiredValues = async () => {
        Object.values(this.$refs).forEach(ref => {
          if (ref && ref.classList && ref.classList.contains('error')) {
            ref.classList.remove('error');
          }
        });
        let result = true;
        
        if (!this.contractInfo.productName || this.contractInfo.productName.length == 0) {
          document.getElementById('product-name-error').innerHTML = '제품명을 선택해 주세요.';
          result = false;
        } else {
          document.getElementById('product-name-error').innerHTML = '';
        }
        if (!this.clientData.companyName) {
          this.$refs.companyName.classList.add('error');
          document.getElementById('company-name-error').innerHTML = '거래처를 선택해 주세요.';
          result = false;
        } else {
          this.$refs.companyName.classList.remove('error');
          document.getElementById('company-name-error').innerHTML = '';
        }
        if (!this.clientData.address) {
          this.$refs.address.classList.add('error');
          document.getElementById('address-error').innerHTML = '주소를 입력해 주세요.';
          result = false;
        } else {
          this.$refs.address.classList.remove('error');
          document.getElementById('address-error').innerHTML = '';
        }
        if (!this.clientData.ceo.name.trim()) {
          this.$refs.ceoName.classList.add('error');
          document.getElementById('ceo-name-error').innerHTML = '대표자 이름을 입력해 주세요.';
          result = false;
        } else {
          this.$refs.ceoName.classList.remove('error');
          document.getElementById('ceo-name-error').innerHTML = '';
        }

        if (this.clientData.ceo.name.trim().length < 2) {
          this.$refs.ceoName.classList.add('error');
          document.getElementById('ceo-name-error').innerHTML = '이름은 최소 2글자 이상으로 작성해 주세요.';
          result = false;
        } else {
          this.$refs.ceoName.classList.remove('error');
          document.getElementById('ceo-name-error').innerHTML = '';
        }
        
        if (!this.contractInfo.installDate) {
          this.$refs.installDate.classList.add('error');
          document.getElementById('install-date-error').innerHTML = '설치일을 입력해 주세요.';
          result = false;
        } else {
          this.$refs.installDate.classList.remove('error');
          document.getElementById('install-date-error').innerHTML = '';
        }

        if (!this.contractInfo.installCount) {
          this.$refs.installCount.classList.add('error');
          document.getElementById('install-count-error').innerHTML = '설치대수를 입력해 주세요.';
          result = false;
        } else {
          this.$refs.installCount.classList.remove('error');
          document.getElementById('install-count-error').innerHTML = '';
        }

        // if (!this.paymentInfo.selectedPaymentOption) {
        //   document.getElementById('payment-0').focus();
        //   document.getElementById('payment-method-error').innerHTML = '결제 방법을 선택해 주세요.';
        //   result = false;
        // } else {
        //   document.getElementById('payment-method-error').innerHTML = '';
        // }
        // console.log(this.paymentInfo.selectedPaymentOption === 'CMS' && !this.paymentInfo.paymentDate)
        // console.log(this.paymentInfo.selectedPaymentOption)
        // console.log(this.paymentInfo.paymentDate)
        // if (this.paymentInfo.selectedPaymentOption === 'CMS' && !this.paymentInfo.paymentDate) {
        //   if (this.$refs.paymentDate) this.$refs.paymentDate.classList.add('error');
        //   if (document.getElementById('payment-date-error'))
        //     document.getElementById('payment-date-error').innerHTML = '결제일을 선택해 주세요.';
        //   result = false;
        // } else {
        //   if (this.$refs.paymentDate) this.$refs.paymentDate.classList.remove('error');
        //   if (document.getElementById('payment-date-error'))
        //     document.getElementById('payment-date-error').innerHTML = '';
        // }

        // const totalUnit = this.productInfo.reduce((total, product) => total + parseInt(product.unit), 0)
        // for (let i = 0; i < this.productInfo.length; i++) {
        //   if (document.getElementById(`productInfoName${i}`) && !document.getElementById(`productInfoName${i}`).value)
        //     document.getElementById(`productInfoName${i}`).classList.add('error');
        //   if (document.getElementById(`productInfoUnit${i}`) && !document.getElementById(`productInfoUnit${i}`).value)
        //     document.getElementById(`productInfoUnit${i}`).classList.add('error');
        // }
        // if (totalUnit === 0) {
        //   document.getElementById('product-info-error').innerHTML = '제품 구성을 하나 이상 입력해 주세요.';
        // } else {
        //   document.getElementById('product-info-error').innerHTML = '';
        // }

        // if (!this.additionalInfo.deadline) {
        //   this.$refs.deadline.classList.add('error');
        //   document.getElementById('deadline-error').innerHTML = '인도기일을 선택해 주세요.';
        //   result = false;
        // } else {
        //   this.$refs.deadline.classList.remove('error');
        //   document.getElementById('deadline-error').innerHTML = '';
        // }
        // if (!this.additionalInfo.installCost) {
        //   this.$refs.installCost.classList.add('error');
        //   document.getElementById('install-cost-error').innerHTML = '변경 설치 비용을 입력해 주세요.';
        //   result = false;
        // } else {
        //   this.$refs.installCost.classList.remove('error');
        //   document.getElementById('install-cost-error').innerHTML = '';
        // }
        // if (!this.additionalInfo.warrantyPeriod) {
        //   this.$refs.warrantyPeriod.classList.add('error');
        //   document.getElementById('warranty-period-error').innerHTML = '품질 보증 기간을 입력해 주세요.';
        //   result = false;
        // } else {
        //   this.$refs.warrantyPeriod.classList.remove('error');
        //   document.getElementById('warranty-period-error').innerHTML = '';
        // }
        if (!this.clientData.contact.mobile) {
          this.$refs.companyMobileNumber.classList.add('error');
          document.getElementById('mobile-error').innerHTML = '휴대폰 번호를 입력해 주세요.';
          result = false;
        } else {
          this.$refs.companyMobileNumber.classList.remove('error');
          document.getElementById('mobile-error').innerHTML = '';
        }

        if (!this.directInputClientName) {
          if (!this.personInCharge.dept.trim()) {
            this.$refs.dept.classList.add('error');
            document.getElementById('dept-error').innerHTML = '영업지점을 입력해 주세요.';
            result = false;
          } else {
            this.$refs.dept.classList.remove('error');
            document.getElementById('dept-error').innerHTML = '';
          }
        } else {
          // todo a-select error 처리
        }
        if (!this.installationPersonName) {
          this.$refs.installationPersonName.classList.add('error');
          document.getElementById('install-person-name-error').innerHTML = '설치 담당자명을 입력해 주세요.';
          result = false;
        } else {
          this.$refs.installationPersonName.classList.remove('error');
          document.getElementById('install-person-name-error').innerHTML = '';
        }
        if (!this.installationPersonMobileNumber) {
          this.$refs.installationPersonMobileNumber.classList.add('error');
          document.getElementById('install-person-mobile-error').innerHTML = '설치 담당자의 휴대전화 번호를 입력해 주세요.';
          result = false;
        } else {
          this.$refs.installationPersonMobileNumber.classList.remove('error');
          document.getElementById('install-person-mobile-error').innerHTML = '';
        }
        if (!this.personInCharge.name.trim()) {
          this.$refs.personInChargeName.classList.add('error');
          document.getElementById('person-in-charge-error').innerHTML = '영업 담당자명을 입력해 주세요.';
          result = false;
        } else {
          this.$refs.personInChargeName.classList.remove('error');
          document.getElementById('person-in-charge-error').innerHTML = '';
        }
        if (!this.personInCharge.mobile.trim()) {
          this.$refs.personMobileNumber.classList.add('error');
          document.getElementById('person-in-charge-mobile-error').innerHTML = '영업 담당자의 휴대전화 번호를 입력해 주세요.';
          result = false;
        } else {
          this.$refs.personMobileNumber.classList.remove('error');
          document.getElementById('person-in-charge-mobile-error').innerHTML = '';
        }
        // if (!this.contractDate) {
        //   this.$refs.contractDate.classList.add('error');
        //   document.getElementById('contract-date-error').innerHTML = '계약일을 입력해 주세요.';
        //   result = false;
        // } else {
        //   this.$refs.contractDate.classList.remove('error');
        //   document.getElementById('contract-date-error').innerHTML = '';
        // }
        
        if (!this.contractInfo.inspectionEquipment.check || !this.contractInfo.inspectionEquipmentName) {
          this.$refs.inspectionEquipmentName.classList.add('error');
          document.getElementById('inspection-equipment-error').innerHTML = '검사 설비를 선택해 주세요.';
          result = false;
        } else {
          this.$refs.inspectionEquipmentName.classList.remove('error');
          document.getElementById('inspection-equipment-error').innerHTML = '';
        }
        if (!this.personInCharge.dept) {
          this.$refs.dept.classList.add('error');
          document.getElementById('dept-error').innerHTML = '지점명을 입력해주세요.';
          result = false;
        } else {
          this.$refs.dept.classList.remove('error');
          document.getElementById('dept-error').innerHTML = '';
        }
        // 거래처 상호 길이 검증 (modusign metadata 80자 제한)
        const clientNameCheck = validateContractClientNameLength({
          name: this.clientData.companyName,
          manager: this.clientData.ceo.name,
          mobile: this.clientData.contact.mobile,
        });
        if (!clientNameCheck.ok) {
          this.$refs.companyName.classList.add('error');
          document.getElementById('company-name-error').innerHTML = clientNameCheck.message;
          result = false;
        } else if (this.clientData.companyName) {
          this.$refs.companyName?.classList.remove('error');
          const _el = document.getElementById('company-name-error');
          if (_el) _el.innerHTML = '';
        }

        return result;
      }

      const validatePhoneNumber = async (input) => {
        if (input == "") return false;
        var regExp = /^\d{2,4}-\d{3,4}-\d{4}$/;
        return regExp.test(input);
      }
      const validateMobileNumber = async (input) => {
        if (!input) return false;
        if (!input.startsWith('01') || input.length < 12) {
          return false;
        }
        if (input.startsWith('010-0')) {
          return false;
        }
        if (input.startsWith('01') && !input.startsWith('010') && input.length < 12) {
          return false;
        }
        if (input.startsWith('010') && input.length < 13) {
          return false;
        }
        return true;
      }

      const validateData = async () => {
        this.validateCount++;
        const isRequiredFilled = await validateRequiredValues();
        if (!isRequiredFilled) {
          await oneBtnDialog('필수값 누락', '필수값을 모두 입력해 주세요.', false);
          return false;
        }

        const isCeoMobileNumberValid = await validateMobileNumber(this.clientData.contact.mobile);
        if (!isCeoMobileNumberValid) {
          this.$refs.companyMobileNumber.classList.add('error');
          document.getElementById('mobile-error').innerHTML = '휴대폰 번호를 올바르게 입력해 주세요.';
          await oneBtnDialog('휴대폰 번호 오류', '휴대폰 번호를 올바르게 입력해 주세요.', false);
          return false;
        } else {
          this.$refs.companyMobileNumber.classList.remove('error');
          document.getElementById('mobile-error').innerHTML = '';
        }

        const isPersonMobileNumberValid = await validateMobileNumber(this.personInCharge.mobile);
        if (!isPersonMobileNumberValid) {
          this.$refs.personMobileNumber.classList.add('error');
          document.getElementById('person-in-charge-mobile-error').innerHTML = '영업 담당자의 휴대전화 번호를 올바르게 입력해 주세요.';
          await oneBtnDialog('휴대폰 번호 오류', '휴대폰 번호를 올바르게 입력해 주세요.', false);
          return false;
        } else {
          this.$refs.personMobileNumber.classList.remove('error');
          document.getElementById('person-in-charge-mobile-error').innerHTML = '';
        }

        return true;
      }
      const parseClientData = (client) => {
        this.clientData.address = '';
        this.clientData.ceo.name = '';
        this.clientData.ceo.birthday = null;
        this.clientData.contact.mobile = '';
        this.clientData.contact.phone = '';
        this.personInCharge.dept = '';
        this.personInCharge.name = '';
        this.personInCharge.mobile = '';

        if (client.bizAddr || (client.addrOne && client.addrTwo && client.addrThree)) {
          this.clientData.address = client.bizAddr;
          this.$refs.address.classList.remove('error');
          document.getElementById('address-error').innerHTML = '';
        }
        if (client.ceo) {
          this.clientData.ceo.name = client.ceo;
          this.$refs.ceoName.classList.remove('error');
          document.getElementById('ceo-name-error').innerHTML = '';
        }
        if (client.ceoMobile) {
          this.clientData.contact.mobile = phoneNumberFormatter(client.ceoMobile);
          this.$refs.companyMobileNumber.classList.remove('error');
          document.getElementById('mobile-error').innerHTML = '';
        }

        if (client.empInfo) {
          if (client.empInfo.empDept) {
            this.personInCharge.dept = client.empInfo.empDept;
            this.$refs.dept.classList.remove('error');
            document.getElementById('dept-error').innerHTML = '';
          }
          if (client.empInfo.empName) {
            this.personInCharge.name = client.empInfo.empName;
            this.$refs.personInChargeName.classList.remove('error');
            document.getElementById('person-in-charge-error').innerHTML = '';
          }
          if (client.empInfo.empMobile) {
            this.personInCharge.mobile = phoneNumberFormatter(client.empInfo.empMobile);
            this.$refs.personMobileNumber.classList.remove('error');
            document.getElementById('person-in-charge-mobile-error').innerHTML = '';
          }
        }
      }
      const getDateFromEpochTime = (value) => {
        if (!value) return '';
        return dayjs(value).format('YYYY-MM-DD');
      }
      const getEpochTimeFromDate = (dateString) => {
        if (!dateString) return 0;
        return dayjs(dateString, 'YYYY-MM-DD');
      }
      const changePhoneNumber = () => {
        this.clientData.contact.phone = phoneNumberFormatter(this.clientData.contact.phone);
        this.$refs.companyPhoneNumber.classList.remove('error');
        document.getElementById('phone-error').innerHTML = '';
      }

      const changeMobileNumber = (isCeo) => {
        if (isCeo) {
          this.clientData.contact.mobile = phoneNumberFormatter(this.clientData.contact.mobile);
          this.$refs.companyMobileNumber.classList.remove('error');
          document.getElementById('mobile-error').innerHTML = '';
        } else {
          this.personInCharge.mobile = phoneNumberFormatter(this.personInCharge.mobile);
          this.$refs.personMobileNumber.classList.remove('error');
          document.getElementById('person-in-charge-mobile-error').innerHTML = '';
        }
      }
      const changeMobileNumberforInstallationPerson = (isCeo) => {
          this.installationPersonMobileNumber = phoneNumberFormatter(this.installationPersonMobileNumber);
          this.$refs.installationPersonMobileNumber.classList.remove('error');
          document.getElementById('install-person-mobile-error').innerHTML = '';
      }

      const handleContractDateOne = (value) => {
        this.contractInfo.contractDate = value;
        this.$refs.contractDateOne.classList.remove('error');
        document.getElementById('contract-date-one-error').innerHTML = '';
      }
      const handleInstallDate = (value) => {
        this.contractInfo.installDate = value;
        this.$refs.installDate.classList.remove('error');
        document.getElementById('install-date-error').innerHTML = '';
      }
      const handleInstallCount = (event) => {
        let inputValue = event.target.value;
        this.contractInfo.installCount = inputValue;
        this.$refs.installCount.classList.remove('error');
        document.getElementById('install-count-error').innerHTML = '';
      }
      const handleContractDate = (value) => {
        this.contractDate = value;
        this.$refs.contractDate.classList.remove('error');
        document.getElementById('contract-date-error').innerHTML = '';
      }
      const handlePaymentDate = (value) => {
        this.paymentInfo.paymentDate = value;
        this.$refs.paymentDate.classList.remove('error');
        document.getElementById('payment-date-error').innerHTML = '';
      }
      const handleDeadline = (value) => {
        this.additionalInfo.deadline = value;
        this.$refs.deadline.classList.remove('error');
        document.getElementById('deadline-error').innerHTML = '';
      }
      const handleRemoveError = (ref, id) => {
        if (this.$refs[ref]) {
          this.$refs[ref]?.classList.remove('error');
        } else {
          document.getElementById(ref)?.classList?.remove('error');
        }
        document.getElementById(id).innerHTML = '';
      }
      const handleMultiRemoveError = (ref, id) => {
        if (this.validateCount === 0) return;
        if (this.$refs[ref]) {
          this.$refs[ref]?.classList.remove('error');
        } else {
          document.getElementById(ref)?.classList?.remove('error');
        }
        let showProductListErrorFlag = false;
        this.productInfo.forEach((item, index) => {
          if (!item.name) {
            showProductListErrorFlag = true;
            document.getElementById(`productInfoName${index}`).classList.add('error');
          } else {
            document.getElementById(`productInfoName${index}`).classList.remove('error');
          }
          if (!item.unit) {
            showProductListErrorFlag = true;
            document.getElementById(`productInfoUnit${index}`).classList.add('error');
          } else {
            document.getElementById(`productInfoUnit${index}`).classList.remove('error');
          }
        });
        if (!showProductListErrorFlag) document.getElementById(id).innerHTML = '';
      }

      const makeContractParam = () => {
        const contract = {
          productName: this.contractInfo.productName,
          contractDate: getDateFromEpochTime(this.contractDate),
          installmentDate: getDateFromEpochTime(this.contractInfo.installDate),
          installmentCount: this.contractInfo.installCount,
          guideDate: getDateFromEpochTime(this.additionalInfo.deadline),
          cmsEndDate: getDateFromEpochTime(this.paymentInfo.paymentDate),
          totalAmount: this.contractInfo.totalPrice,
          installmentAmount: this.additionalInfo.installCost,
          warrantyYear: this.additionalInfo.warrantyPeriod,
          paymentMethod: this.paymentInfo.selectedPaymentOption,
          productName1: this.productInfo[0]?.name,
          productName2: this.productInfo[0]?.name,
          count1: this.productInfo[0]?.unit,
          remark: this.productRemark,
          brightAloneS: this.contractInfo.productName == 'bright Alone S' ? true : false,
          brightAloneR: this.contractInfo.productName == 'bright Alone R' ? true : false,
          brightChair2: this.contractInfo.productName == 'bright Chair2' ? true : false,
          personInChargeName: this.personInCharge.name,
          inspectionEquipment: this.contractInfo.inspectionEquipment.check,
          inspectionEquipmentName: this.contractInfo.inspectionEquipmentName,
          installationPersonName:this.installationPersonName,
          installationPersonMobileNumber:this.installationPersonMobileNumber,
        }
        return {
          templateId: this.templateId,
          contractCreator: this.contractCreator,
          contractType: this.contractType,
          contractTitle: this.contractTitle,
          clientInfos: [
            {
              name: this.clientData.companyName
                  .replace('(출고정지)', '')
                  .replace('(거래중지_악성미수)', '')
                  .replace('(거래중지-영본확인)', '')
                  .replace('(거래정지)', ''),
              bizNo: this.clientData.cNo,
              address: `${this.clientData.address}`.trim(),
              manager: this.clientData.ceo.name,
              mobile: this.clientData.contact.mobile,
            }
          ],
          seller: {
            branch: this.personInCharge.dept,
            manager: this.personInCharge.name,
            mobile: this.personInCharge.mobile,
          },
          contract
        }
      }

      const createContract = async () => {
        if (this.selectedPaymentOption === 'CMS') obj.cmsEndDate = this.paymentInfo.paymentDate;
        await this.apiHandler.createContract(
            makeContractParam(),
            async (response) => {
              // 24/02/01 배포이후 항상 SECURE_LINK 로 생성
              this.secureLinkParam = {
                contractId: response.data.id,
                participantId: response.data.participants[0]?.id,
              }
              this.uiHandler.handleModal.createSuccess.show()
            }, async (error) => {
              // this.secureLinkParam = {
              //   contractId: 'cb7b02f0-a48b-11ee-9678-f355b6d3789f',
              //   participantId: 'cba79130-a48b-11ee-81a0-03e90a0291d0'
              // }
              // this.uiHandler.handleModal.createSuccess.show()
              await oneBtnDialog('계약 추가 실패', '신규 계약서 작성에 실패하였습니다.', false);
            }
        )
      }
      return {
        searchAddress,
        changeInspectionEquipment,
        handleProductUnit: () => {
          return {
            input: (e, index) => {
              const product = this.productInfo[index]

              const str = e.target.value.replace(/[^0-9]/g, '');
              e.target.value = str;

              let parsedValue = Number.parseInt(str)

              if (isNaN(parsedValue)) {
                parsedValue = 0;
              }

              product.unit = parsedValue;
              this.productInfo.splice(index, 1, product);

              logging().exceptProd('handleProductUnit input===>', this.productInfo)
            },
            focusin: (e, index) => {
              const product = this.productInfo[index]
              if (product.unit === 1) {
                product.unit = ''
              }
              this.productInfo.splice(index, 1, product)
            },
            focusout: (e, index) => {
              const product = this.productInfo[index]
              product.unit = product.unit || 1
              this.productInfo.splice(index, 1, product)
            }
          }
        },
        handleProductOption: async (value) => {
          // if (this.productInfo.length === 10) {
          //   await oneBtnDialog("알림", "품목은 최대 10개까지 선택이 가능합니다.")
          //   return
          // }
          this.selectedValues = [value]
          this.productInfo = this.selectedValues.map(v => {
            let existingItem = this.productInfo.find(pi => pi.name === v) || {};
            return {
              name: v,
              unit: existingItem.unit || 1,
              remark: existingItem.remark || ''
            }
          })
        },
        handlePaymentOption,
        removeProductInfo,
        addProductInfo,
        getContractTemplate,
        changePhoneNumber,
        changeMobileNumber,
        changeMobileNumberforInstallationPerson,
        handleContractDateOne,
        handleInstallDate,
        handleInstallCount,
        handleContractDate,
        handlePaymentDate,
        handleDeadline,
        removeTotalPrice,
        removeInstallCost,
        removeWarrantyPeriod,
        addZeroToTotalPrice,
        addZeroToInstallCost,
        addZeroToWarrantyPeriod,
        handleTotalPrice,
        handleInstallCost,
        handleWarrantyPeriod,
        handleRemoveError,
        handleMultiRemoveError,
        changePersonInChareName,
        handleChangeInstallationPerson,
        handleChangeInspectionEquipmentName,
        handleModal: {
          client: {
            show: () => this.modal.client.show = true,
            close: () => this.modal.client.show = false,
            handleEvent: {
              selectClient: async (client) => {
                this.clientData.rawHospitalData = client;
                this.clientData.cNo = businessNumberFormatter(client.cNo);
                this.clientData.companyName = client.name;
                this.$refs.companyName.classList.remove('error');
                document.getElementById('company-name-error').innerHTML = '';
                parseClientData(client);
                this.modal.client.show = false;
              }
            }
          },
          summary: {
            show: async () => {
              if (!await validateData()) return;
              this.summary = {
                계약명: this.contractTitle,
                병원명: `${this.clientData.companyName} (${this.clientData.cNo ? this.clientData.cNo : '거래처 직접 입력 - 사업자등록번호 발급전 입니다.'})`,
                병원장명: this.clientData.ceo.name,
                "병원 주소": `${this.clientData.address}`,
                // "병원 연락처": `(유선전화) ${this.clientData.contact.phone}/(휴대전화) ${this.clientData.contact.mobile}/(이메일) ${this.clientData.contact.email}`,
                "병원 연락처": `(휴대전화) ${this.clientData.contact.mobile}`,
                "총 계약 금액": this.contractInfo?.totalPrice
              }
              this.modal.summary.show = true
            },
            close: () => this.modal.summary.show = false,
            handleEvent: {
              summaryConfirm: async (childPassParam) => {
                await createContract();
              }
            }
          },
          createSuccess: {
            show: () => {
              this.modal.summary.show = false;
              this.modal.createSuccess.show = true
            },
            close: () => this.modal.createSuccess.show = false,
          },
          contractDraftModal: {
            show: async () => {
              this.$store.commit('setIsLoading', true);
              await this.uiHandler.makeContractDraft();
              this.modal.contractDraft.show = true
              this.$store.commit('setIsLoading', false);
            },
            close: () => this.modal.contractDraft.show = false
          }
        },
        getUserInfo: () => {
          const data = JSON.parse(localStorage.getItem(localStorageEnums.CompanyInfo));
          this.contractCreator = data?.accountInfo?.username;
        },
        makeContractDraft: async () => {
          this.previewLoading = true
          // 거래처 상호 길이 가드: 미리보기/초안 자동생성 경로 (modusign metadata 80자 제한)
          // 자동 호출 경로이므로 모달 금지 — 인라인 에러 표시 후 API 호출 skip
          const _previewClientNameCheck = validateContractClientNameLength({
            name: this.clientData.companyName,
            manager: this.clientData.ceo.name,
            mobile: this.clientData.contact.mobile,
          });
          if (!_previewClientNameCheck.ok) {
            this.$refs.companyName.classList.add('error');
            document.getElementById('company-name-error').innerHTML = _previewClientNameCheck.message;
            this.previewLoading = false;
            return;
          } else if (this.clientData.companyName) {
            this.$refs.companyName?.classList.remove('error');
            const _el = document.getElementById('company-name-error');
            if (_el) _el.innerHTML = '';
          }
          // console.log(makeContractParam())
          // return false;
          await this.apiHandler.createContractDraft(
              makeContractParam(),
              async (response) => {
                this.modal.contractDraft.embeddedUrl = `${response?.data?.embeddedUrl}&mode=preview`;
              }, async (error) => {
                // this.secureLinkParam = {
                //   contractId: 'cb7b02f0-a48b-11ee-9678-f355b6d3789f',
                //   participantId: 'cba79130-a48b-11ee-81a0-03e90a0291d0'
                // }
                // this.uiHandler.handleModal.createSuccess.show()
                await oneBtnDialog('계약 초안 생성 실패', '신규 계약서 초안 생성에 실패하였습니다.', false);
              }
          ).finally(() => this.previewLoading = false)
        },
        checkScreenSizeAndFetch: async () => {
          if (this.makeContractDraftDebouncing) {
            clearTimeout(this.makeContractDraftDebouncing);
          }

          const thisObj = this;
          this.makeContractDraftDebouncing = setTimeout(async function() {
            await thisObj.uiHandler.makeContractDraft();
          },500);
        },
        checkDirectInputClientName: (e) => {
          // 매수인 정보 클리어
          this.clientData.companyName = ''
          this.clientData.ceo.name = ''
          this.clientData.ceo.birthday = null
          this.clientData.cNo = ''
          this.clientData.address = ''
          this.clientData.contact.mobile = ''
          // 영업담당자 정보
          this.personInCharge.name = ''
          this.personInCharge.dept = ''
          this.selectedDept = null
          this.personInCharge.mobile = ''
          // 체크박스 토글
          this.directInputClientName = e.target.checked
        },
        loadDeptNames: async () => {
          await this.apiHandler.getDistinctDeptName({}, (deptNames) => {
            this.deptNames = deptNames;
          }, (error) => {
            console.error('Failed to load department names', error);
          });
        },
        createTempContract: async (e) => {
          const confirm = await twoBtnDialog('안내', '계약서를 임시저장 하시겠습니까?', '저장')
          if (confirm) {
            await this.apiHandler.createTempContract({
              contractType: this.contractType,
              payload: {...makeContractParam(), directInputClientName: this.directInputClientName}
            }, (response) => {
              console.log("create temp contract==>", response)
            }, (error) => {
              console.log("create temp contract==>", error)
            })
          }
        },
        loadTempContract: async () => {
          await this.apiHandler.getTempContract({
            contractType: this.contractType,
          }, async (result) => {
            const {payload} = result
            if (payload) {
              const confirm = await twoBtnDialog('안내', '임시저장된 계약서 내용이 있습니다. 불러오시겠습니까?', '확인')
              if (confirm) {
                const clientInfo = payload.clientInfos[0]
                const seller = payload.seller
                const contract = payload.contract
                const extractProductInfo = (contract) => {
                  const productInfo = [];
                  productInfo.push({
                    name: contract[`productName1`],
                    unit: contract[`count1`],
                    remark: contract[`remark`]
                  });
                  return productInfo;
                }

                // 병원정보
                this.clientData.companyName = clientInfo.name
                this.clientData.ceo.name = clientInfo.manager
                this.clientData.cNo = clientInfo.bizNo
                this.clientData.address = clientInfo.address
                this.clientData.contact.mobile = clientInfo.mobile
                this.directInputClientName = payload.directInputClientName
                // 계약담당자 정보
                this.personInCharge.mobile = seller.mobile
                this.personInCharge.dept = seller.branch
                this.selectedDept = seller.branch
                this.personInCharge.name = seller.manager
                // 계약 정보
                this.contractDate = getEpochTimeFromDate(contract.contractDate)
                this.contractInfo.installDate = getEpochTimeFromDate(contract.installmentDate)
                this.contractInfo.paymentDate = getEpochTimeFromDate(contract.cmsEndDate)
                this.additionalInfo.deadline = getEpochTimeFromDate(contract.guideDate)
                this.additionalInfo.installCost = contract.installmentAmount
                this.contractInfo.totalPrice = contract.totalAmount
                this.contractInfo.selectedPaymentOption = contract.paymentMethod
                this.paymentInfo.selectedPaymentOption = contract.paymentMethod
                this.productInfo = extractProductInfo(contract)
                this.selectedValues = this.productInfo.map(p => p.name)
                this.productRemark = this.productInfo[0].remark
                this.contractInfo.productName = contract.productName;
                this.contractInfo.installCount = contract.installmentCount;
                this.contractInfo.inspectionEquipment.check = contract.inspectionEquipment;
                this.contractInfo.inspectionEquipment.name = contract.inspectionEquipment ? '디지털 멀티미터' :'';
                this.contractInfo.inspectionEquipmentName = contract.inspectionEquipmentName;
                this.installationPersonName = contract.installationPersonName;
                this.installationPersonMobileNumber = contract.installationPersonMobileNumber;
                // 계약서 미리보기에 반영하기
                await this.uiHandler.makeContractDraft()
              }
            }
          }, (err) => {
            console.log("get temp contract error==>", err);
          })
        }
      }
    },
    api() {
      return contractApi(contractsApiInstance, this.$store)
    },
  }
}
</script>
<style scoped>
.titleContainer {
  margin-bottom: 30px;

  .title {
    font-size: 24px;
    font-weight: bold;
    color: #2F3337;
    line-height: 1.2;
    margin-bottom: 5px;
    letter-spacing: 0;
  }

  .desc {
    color: #6e747c;
    font-weight: 400;
  }
}

.productRemark {
  text-align: left;
  width: 100%;
  height: 120px;
  border-radius: 8px;
  border: 1px #ced4da solid;
  resize: none;
  padding: 10px;
}

.productRemark::placeholder {
  color: #8D939A;
  font-size: 16px;
}
</style>
<style scoped lang="scss">
@import '@/assets/scss/contract-detail.scss';

.ant-select {

  .ant-select-selector {
    .ant-select-selection-placeholder {
      color: #8D939A !important;
    }

    &:hover {
      border: none !important;
      border: 2px solid #0946c0 !important;
    }

    &:focus {
      border: 2px solid #0946c0 !important;
    }
  }


}






/* [2026-08-24] 프릭스 미리보기 — 크고 선명하게. 상세 근거는 utils/prixPreviewFit.js 주석 참조.
   요지: 뷰어는 로드 시점의 iframe 폭으로 배율을 이산적으로 고른다. 1100px 로 두어야 100%(문서 약 702px)로
   그려진다. 그 문서는 컨테이너(약 673px)보다 커서 그냥 두면 양옆이 잘리므로, 컨테이너 폭에 맞춘 축소를
   attachPrixPreviewFit() 이 인라인 transform/margin-left 로 넣는다(부모 폭은 CSS 로 알 수 없다).
   1차 시도였던 scale(1.3) 확대는 픽셀을 늘리는 방식이라 흐려져 폐기했다 — 축소는 흐려지지 않는다.
   [HARD] 전역 .preview-iframe / .iframe-wrap(assets/scss/contract-detail.scss)은 V1 화면 22 개가
   공유하므로 건드리지 않는다 — scoped 선택자([data-v-*])가 우선순위에서 이겨 V3 에만 적용된다. */
.iframe-wrap {
  overflow: hidden;
}

.preview-iframe {
  width: 1100px;
  flex-shrink: 0; /* .iframe-wrap 이 flex 라 지정하지 않으면 컨테이너 폭으로 줄어든다 */
  transform-origin: top left;
}
</style>
